import { useTranslation } from 'react-i18next';
import { Segmented } from 'antd';
import { ELocationMode } from 'components/trips/trip-create-task-modal/types';
import type { ILocationSwitcherProps } from './types';

export const LocationSwitcher = (props: ILocationSwitcherProps) => {
  const { value, onChange, showFromCargo = false } = props;
  const { t } = useTranslation('trip');

  const options = [
    ...(showFromCargo ? [{ label: t('location_mode_from_cargo'), value: ELocationMode.fromCargo }] : []),
    { label: t('location_mode_address'), value: ELocationMode.address },
    { label: t('location_mode_coordinates'), value: ELocationMode.coordinates },
  ];

  return <Segmented options={options} value={value} block onChange={onChange} />;
};
